{
  "es": {
    "integration": {
      "actions": {
        "goTo": "Ir a {name}"
      },
      "labels": {
        "apiTokensUsedByYou": "Tokens de API",
        "create_failed": "Error al crear",
        "crm_id": "ID de {integration_oid_type} en {integration_name}: {integration_oid}",
        "description": "Descripción",
        "error": "error",
        "integration": "Integración",
        "integrationOID": "ID de integración",
        "last_sync_with": "Última sincronización con {integration_name} ({last_sync_at})",
        "status": "estado",
        "synced_at": "Última sincronización: ",
        "title": "Integraciones gestionadas por Ziggu",
        "update_failed": "error al actualizar"
      },
      "record_actions": {
        "delete": "Para que {record_type} se elimine de forma permanente en Ziggu (y no vuelva a aparecer), primero <strong>debe eliminarse en {integration_name}</strong>."
      },
      "toasts": {
        "update": "Integración actualizada"
      }
    }
  }
}
